<template>
    <Notification
        v-if="messages.length > 0"
        class="modal-errors-notification"
        variant="negative"
        padding="l"
        :tier="2">
        <div class="modal-errors-notification-content">
            <div class="modal-errors-notification-description">
                <span v-for="(message, index) in messages" :key="index">
                    {{ message }}
                </span>
            </div>

            <ButtonLink :onClick="onHide" class="modal-errors-notification-button">
                {{ t({ key: 'shared.close' }) }}
            </ButtonLink>
        </div>
    </Notification>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType, ref, watch } from 'vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';
    import Notification from '@ui/components/Notification/Notification.vue';

    export default defineComponent({
        name: 'Errors',
        components: { ButtonLink, Notification },
        methods: { t },
        props: {
            errors: Array as PropType<string[]>,
        },
        setup(props) {
            const messages = ref<string[]>([]);

            watch(
                () => props.errors,
                (newValue) => {
                    messages.value = newValue ?? [];
                }
            );

            function onHide() {
                messages.value = [];
            }

            return {
                messages,
                onHide,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Errors.scss';
</style>
